
module.exports = {

    GetIncreasePopulationCost: (yellowBank) => {
        if (yellowBank === 0)
        {
            return null;
        }
        if (yellowBank <=4)
        {
            return 7;
        }
        if (yellowBank <=8)
        {
            return 5;
        }
        if (yellowBank <=12)
        {
            return 4;
        }
        if (yellowBank <=16)
        {
            return 3;
        }
        return 2;
    },

    GetConsumption: (yellowBank) => {
        if (yellowBank === 0)
        {
            return 6;
        }
        if (yellowBank <=4)
        {
            return 4;
        }
        if (yellowBank <=8)
        {
            return 3;
        }
        if (yellowBank <=12)
        {
            return 2;
        }
        if (yellowBank <=16)
        {
            return 1;
        }
        return 0;
    },

    // Matches the sections drawn in BlueBank: 0 tokens -> 6, 1-5 -> 4, 6-10 -> 2, 11+ -> 0
    GetCorruption: (blueBank) => {
        if (blueBank === 0)
        {
            return 6;
        }
        if (blueBank <= 5)
        {
            return 4;
        }
        if (blueBank <= 10)
        {
            return 2;
        }
        return 0;
    },

    // Civil actions needed to take the card in a given card row slot (0-12)
    GetCardRowCost: (slotIndex) => {
        if (slotIndex < 5)
        {
            return 1;
        }
        if (slotIndex < 9)
        {
            return 2;
        }
        return 3;
    },

    // Slots cleared from the front of the card row at the start of each turn
    GetCardRowRemovalCount: (playerCount) => Math.max(5 - playerCount, 1),

    // Happy faces the populace requires: the number above the leftmost empty subsection of the yellow bank.
    // The yellow bank empties from the right; its subsections hold (left to right) 2,2 | 2,2 | 2,2 | 4 | 2 tokens
    // and require 8,7 | 6,5 | 4,3 | 2 | 1 happy faces.
    GetRequiredHappyFaces: (yellowBank) => {
        if (yellowBank >= 17) return 0;
        if (yellowBank >= 13) return 1;
        if (yellowBank >= 11) return 2;
        if (yellowBank >= 9) return 3;
        if (yellowBank >= 7) return 4;
        if (yellowBank >= 5) return 5;
        if (yellowBank >= 3) return 6;
        if (yellowBank >= 1) return 7;
        return 8;
    },
}